export const CHECKOUT_KEY = "uagCheckoutKey"
export const CUSTOMER_COUNTRY_CODE_KEY = "uagCustomerCountryCodeKey"
export const CUSTOMER_STATE_CODE_KEY = "uagCustomerStateCodeKey"
export const CUSTOMER_ZIP_CODE_KEY = "uagCustomerZipCodeKey"
export const DISCOUNT_KEY = "uagDiscountKey"
export const ELEVAR_COOKIES_KEY = "uagElevarCookiesKey"
export const LAST_PASSED_DISCOUNT_APPLIED_KEY =
  "uagLastPassedDiscountAppliedKey"
export const MAESTRA_DEVICE_UUID_KEY = "maestraDeviceUUID"
export const MIGRATED_TO_CART_API_KEY = "uagMigratedToCartAPIKey"
export const PASSED_DISCOUNT_KEY = "uagPassedDiscountKey"
export const RECENTLY_VIEWED_PRODUCTS_KEY = "uagRecentlyViewedProductsKey"
export const SELECTED_PRODUCTS_KEY = "uagSelectedProductsKey"
export const SHOPIFY_CA_PKCE_VERIFIER_KEY = "shopify.ca.pkce_verifier"
export const SHOPIFY_CA_TOKENS_KEY = "shopify.ca.tokens"
export const UTM_PARAMS_KEY = "uagUTMParamsKey"
export const VISITOR_INFO_KEY = "uagVisitorInfoKey"
